import React from 'react';
import { usePostHog } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';

import { usePosthogCapture } from 'auth/posthogCapture/_index';

import { Arrow } from 'icons/untitledui';
import PanelNav from 'sidePanel/components/PanelNav';
import { useLogoutMutation } from 'auth/hooks/loginApi';

export default function Logout({
  expanded,
}: {
  expanded: boolean;
}): JSX.Element {
  const { mutate: logout } = useLogoutMutation();
  const posthog = usePostHog();
  const auth = usePosthogCapture();
  const { t } = useTranslation('sidePanel');

  const handleLogout = () => {
    logout();
    auth.loggedOut();
    posthog?.reset();
  };

  return (
    <PanelNav
      action={handleLogout}
      icon={() => <Arrow.ArrowCircleBrokenLeft size={15} />}
      expanded={expanded}
      label={t('logout')}
    />
  );
}
